import { render, staticRenderFns } from "./package-sold-icon.vue?vue&type=template&id=5e9701b2&functional=true&"
import script from "./package-sold-icon.vue?vue&type=script&lang=js&"
export * from "./package-sold-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports